export default __webpack_public_path__ + "static/logo-1098e3fdc2d7cb636ed9f2fdc2f3bc8f.svg";